import React, {useEffect, useState} from 'react'
import ProgramDashboardView from "../../views/ver_24.10/ProgramDashboard/ProgramDashboard.view";
import Icon1 from '../../assets/images/IconImg1.png';
import Icon2 from '../../assets/images/IconImg2.png';
import Icon3 from '../../assets/images/IconImg3.png';
import Icon4 from '../../assets/images/IconImg4.png';
import {useHistory, useParams} from 'react-router-dom';
import {fetchProgramService} from "../../services/program.service";
import {PAYMENT_STATUS, PBDQ3_PROGRAM_STATE} from "../../utils/constants";


const STEPS = [
    {
        label: 'Program Overview',
        icon: Icon1,
        maximum_status: PBDQ3_PROGRAM_STATE.OUTLINE_DRAFT,
        stepIndex: 0,
        height:'40px',
        width:'70px',
    },
    {
        label: 'Your Program',
        icon: Icon2,

        maximum_status: PBDQ3_PROGRAM_STATE.OUTLINE_GENERATED,
        stepIndex: 1,
        height:'45px',
        width:'55px',
    },
    // {
    //     label: 'Your Program With',
    //     icon: Icon3,
    //     maximum_status: PBDQ3_PROGRAM_STATE.OUTLINE_GENERATED,
    //     stepIndex: 2,
    //     height:'45px',
    //     width:'55px',
    // },
    {
        label: 'Resources',
        icon: Icon4,
        maximum_status: PBDQ3_PROGRAM_STATE.OUTLINE_GENERATED,
        stepIndex: 2,
        height:'45px',
        width:'52px',
    },
];


function statusToStepConversion(status) {
    for (let stepIndex = 0; stepIndex < STEPS.length; stepIndex++) {
        if (status <= STEPS[stepIndex].maximum_status) {
            return stepIndex;
        }
    }
    return STEPS.length - 1;
}

//TODO: Need to remove this when actual statuses are updated.
function statusToStepConversion_rev2(status) {
    let maxStep = 0;

    for (let stepIndex = 0; stepIndex < STEPS.length; stepIndex++) {
        if (status >= STEPS[stepIndex].maximum_status) {
            maxStep = stepIndex;
        } else {
            break;
        }
    }

    return maxStep;
}

const ProgramDashboardPage = () => {
    const { programId } = useParams();
    const history = useHistory();
    const [programPaymentStatus, setProgramPaymentStatus] = useState(3);
    const [activeStep, setActiveStep] = useState(0);

    useEffect(() => {
        (async () => {
            if (programId) {
                try {
                    const response = await fetchProgramService(programId);
                    if(response.data) {
                        const fetchedStatus = response.data.existingProgram.program_state;
                        setProgramPaymentStatus(response.data.existingProgram.payment_status);

                        const step = statusToStepConversion_rev2(fetchedStatus);
                        setActiveStep(step);
                    }
                } catch (error) {
                    console.error('Failed to fetch program status:', error);
                }
            }
        })();
    }, [programId]);

    function cardsContent(stepIndex) {
        const contents = [
            'Overview of your curated program',
            'Preview your ready-to-go online program or edit it manually',
            // 'Your created program will automatically adjust its content and lessons based on the learner\'s current skill level or progress. The material is personalized in real-time to better suit each individual\'s needs.',
            'Everything you need to run your program online, offline, or integrate with your system via API',
        ];
        return contents[stepIndex] || '';
    }

    function cardsButtons(stepLabel, isEnabled, programId) {
        switch (stepLabel) {
            case 'Program Overview':
                return [
                    {
                        label: 'View/Edit',
                        url: `/program/${programId}/outline`,
                        stepCompletion: true,
                        enabled: isEnabled,
                    },
                ];
            case 'Your Program':
                return [
                    {
                        label: 'Preview',
                        url: `/program/${programId}/preview`,
                        enabled: isEnabled,
                    },
                    // {
                    //     label: 'Edit',
                    //     url: `/program/${programId}/edit`,
                    //     enabled: isEnabled,
                    // },
                ];
            case 'Your Program With':
                return [
                    {
                        label: 'Enable',
                        url: `/program/${programId}/curation-enable`,
                        enabled: isEnabled,
                    },
                    {
                        label: 'Preview',
                        url: `/program/${programId}/curation-preview`,
                        enabled: isEnabled,
                    },
                ];
            case 'Resources':
                return [
                    {
                        label: 'Access',
                        url: `/program/${programId}/resources`,
                        enabled: programPaymentStatus === PAYMENT_STATUS.SUCCESSFUL,
                    },
                ];
            default:
                return [];
        }
    }


    const cardsData = STEPS.map((step) => {

        const isCardEnabled = step.stepIndex <= activeStep;

        const buttons = cardsButtons(step.label, isCardEnabled, programId);

        return {
            icon: step.icon,
            title: step.label,
            content: cardsContent(step.stepIndex),
            buttons: buttons,
            stepIndex: step.stepIndex,
            height: step.height,
            width: step.width,
        };
    });

    const data = {
        cardsData,
        programPaymentStatus
    }
    const options = {
        activeStep,
    };
    const actions = {
        navigationAction: (url) => {
            history.push(url.replace(':programId', programId));
        },
        upgradeToProAction: () => {
            history.push(`/program/${programId}/upgrade`);
        }
    };

    return (
        <div>
            <ProgramDashboardView
                data={data}
                options={options}
                actions={actions}
            />
        </div>
    );
};

export default ProgramDashboardPage;